// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert_alert__JlQzI","icon":"alert_icon__3wBtv","primary":"alert_primary__v6Z9s","success":"alert_success__3Ayfu","danger":"alert_danger__3jfBZ"};